// extracted by mini-css-extract-plugin
module.exports = {"supportersAnchor":"TotalRaised_supportersAnchor__0HTtg"};